// TODO: Performance - Add lazy loading for routes and components
// TODO: Performance - Memoize theme object to prevent unnecessary re-renders
// TODO: Architecture - Move theme configuration to separate file
// TODO: Performance - Add error boundary for better error handling
import { Suspense, useMemo } from 'react';
import { RouterProvider } from 'react-router-dom';
import { initRouting } from './utils/AppRoutes';

import { ThemeProvider } from '@emotion/react';
import { ProvideAuth } from './hooks/check-auth';
import { ProvideBackgroundUpload } from './hooks/backgroundUpload';
import { AxiosInterceptor } from './utils/request';
import appTheme from './utils/Theme';
import ErrorBoundary from './utils/components/ErrorBoundary/ErrorBoundary';

import './App.css';

const App = () => {
  const router = initRouting();

  // ✅ Memoize theme to prevent unnecessary re-renders
  const theme = useMemo(() => appTheme, []);

  return (
    <ThemeProvider theme={theme}>
      <ProvideAuth>
        <ProvideBackgroundUpload>
          <AxiosInterceptor>
            <ErrorBoundary>
              <Suspense fallback={<div>Loading...</div>}>
                <RouterProvider router={router} />
              </Suspense>
            </ErrorBoundary>
          </AxiosInterceptor>
        </ProvideBackgroundUpload>
      </ProvideAuth>
    </ThemeProvider>
  );
};

export default App;